export default {"src":"/_next/static/image/src/images/statistic-matters.e354891cc1a603bbfc776751467e5942.svg","height":32,"width":32};